<template>
  <div class="container" v-if="fields">
    <div class="row">
      <div class="col-12">
        <div class="input-group">
          <div class="form-outline">
            <input type="search" id="form1" class="form-control" placeholder="Search"
                   v-model="search" @change="searching(0)"/>
          </div>
          <button type="button" class="btn btn-primary">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <data-table
      :headers="headers"
      :actions="actions"
      :items="items"
  />
  <pagination
      :length="length"
      :onPageChange="pageChange"
  />
</template>

<script>
  import DataTable from "data-table/src/components/DataTable.vue";
  import Pagination from "data-table/src/components/Pagination.vue";

export default {
  name: "DataTable2",
  components: {Pagination, DataTable},
  data() {
    return {
      items:[],
      length:0,
      max:0,
      search:""
    }
  },
  props:{
    actions:Array,
    headers:Object,
    api:Function,
    fields:Array,
    trigger:Object,
    
      mainfilter: Object,
      lista: Array,
      showSearch:Boolean
  },
  methods: {
    async searching(skip) {
      let search = {};
      if(this.search) {
        search["$or"] = [];
        this.fields.forEach(field => {
          let fieldSearch = {}
          fieldSearch[field] = (field == "id" || field == "_id") ? Number(this.search) :{$regex : this.search};
          search["$or"].push(fieldSearch);
        })
      }
      let data = await this.api(search,skip,this.max);
      this.length = data.count;
      this.items = data.data;
    },
    pageChange(page,max) {
      this.max = max;
      let skip = (page-1) * max;
      this.searching(skip);
    }
  },
  created() {
    this.pageChange(1);
    let trigger = this.trigger;
    if(trigger)
      trigger.refresh = () => {
        this.pageChange(1);
      }
  }
}
</script>

<style scoped>

</style>